
namespace Matrix.Dashboards {

    @Serenity.Decorators.registerClass()
    export class DashboardUserGrid extends Serenity.EntityGrid<DashboardUserRow, any> {
        protected getColumnsKey() { return 'Dashboards.DashboardUser'; }
        protected getDialogType() { return DashboardUserDialog; }
        protected getIdProperty() { return DashboardUserRow.idProperty; }
        protected getInsertPermission() { return DashboardUserRow.insertPermission; }
        protected getLocalTextPrefix() { return DashboardUserRow.localTextPrefix; }
        protected getService() { return DashboardUserService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}